import { render, staticRenderFns } from "./commonProblem.vue?vue&type=template&id=72f3de50&scoped=true&"
import script from "./commonProblem.vue?vue&type=script&lang=js&"
export * from "./commonProblem.vue?vue&type=script&lang=js&"
import style0 from "./commonProblem.vue?vue&type=style&index=0&id=72f3de50&prod&lang=scss&"
import style1 from "./commonProblem.vue?vue&type=style&index=1&id=72f3de50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f3de50",
  null
  
)

export default component.exports